/** Regras da tela Materiais que não dependem de cena. */

/** Página do visualizador (paginação e busca), publicada ao lado do jogo. */
export const PAGINA_DO_VISUALIZADOR = './visualizador.html';

/** Mensagens trocadas com o visualizador, dentro do iframe. */
export const MENSAGEM = Object.freeze({ PRONTO: 'fiat-arcade:visualizador-pronto', DOCUMENTO: 'fiat-arcade:documento' });

/**
 * Como o modal abre um material:
 * - `null` — bloqueado (RN-MAT-03) ou ainda sem documento: não há o que abrir;
 * - `{ endereco, entregar: false }` — o documento tem endereço que o navegador baixa sozinho;
 * - `{ endereco, entregar: true }` — o PDF exige a sessão do participante: a tela o baixa
 *   e o entrega ao visualizador por mensagem.
 */
export function aberturaDoMaterial (material) {
    if (!material?.desbloqueado) return null;
    if (material.url) {
        return { endereco: `${PAGINA_DO_VISUALIZADOR}?arquivo=${encodeURIComponent(material.url)}`, entregar: false };
    }
    return material.temArquivo ? { endereco: PAGINA_DO_VISUALIZADOR, entregar: true } : null;
}

/** Endereço do iframe para um material liberado; `null` quando não há o que abrir. */
export function enderecoDoVisualizador (material) {
    return aberturaDoMaterial(material)?.endereco ?? null;
}

/**
 * Entrega o PDF ao visualizador quando ele avisa que está pronto.
 *
 * @param {object} deps
 * @param {Window} deps.janela quem recebe as mensagens (a tela do jogo)
 * @param {() => Window|null} deps.destino a janela do iframe
 * @param {() => Promise<ArrayBuffer>} deps.baixar
 * @param {(falha: unknown) => void} deps.aoFalhar
 * @returns {() => void} cancela a espera (modal fechado)
 */
export function entregarAoVisualizador ({ janela, destino, baixar, aoFalhar }) {
    let cancelado = false;
    const ouvir = async (evento) => {
        // Só o iframe aberto por esta tela, na mesma origem, pode pedir o documento.
        if (evento.origin !== janela.location.origin || evento.source !== destino()) return;
        if (evento.data?.tipo !== MENSAGEM.PRONTO) return;
        janela.removeEventListener('message', ouvir);
        try {
            const dados = await baixar();
            if (!cancelado) destino()?.postMessage({ tipo: MENSAGEM.DOCUMENTO, dados }, janela.location.origin, [dados]);
        } catch (falha) {
            if (!cancelado) aoFalhar(falha);
        }
    };
    janela.addEventListener('message', ouvir);
    return () => {
        cancelado = true;
        janela.removeEventListener('message', ouvir);
    };
}
